/**
 * @generated SignedSource<<aabf29776f1173ce3d7cda5462f78567>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PdpRespSellerInformation_item$data = {
  readonly " $fragmentSpreads": FragmentRefs<"PdpSharedMeetTheSeller_item">;
  readonly " $fragmentType": "PdpRespSellerInformation_item";
};
export type PdpRespSellerInformation_item$key = {
  readonly " $data"?: PdpRespSellerInformation_item$data;
  readonly " $fragmentSpreads": FragmentRefs<"PdpRespSellerInformation_item">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpRespSellerInformation_item",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpSharedMeetTheSeller_item"
    }
  ],
  "type": "Item",
  "abstractKey": null
};

(node as any).hash = "1517cdfa491d4849861f12d94e2fb879";

export default node;
